import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

export default function Artists() {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    api.getArtists()
      .then((data) => {
        setArtists(data.artists || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Failed to load artists:', err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="el-artists-page" data-testid="artists-page">

      {/* Who is CloudfiMusic? */}
      <section className="el-intro">
        <div className="el-intro-inner">
          <h2 className="el-intro-title">Who is CloudfiMusic?</h2>
          <p className="el-intro-text">
            CloudfiMusic is an independent lofi music label founded and operated by
            Xu&acirc;n Di&#7879;u Media Co., Ltd. We discover, nurture, and release
            exceptional ambient and lofi music from artists around the world. Our
            roster represents the finest in chill beats, warm melodies, and
            atmospheric soundscapes &mdash; music designed for focus, relaxation, and
            reflection. From bedroom producers to established ambient artists,
            CloudfiMusic is where sound meets serenity.
          </p>

          <div className="el-listen-block">
            <span className="el-listen-label">Better yet, just listen</span>
            <div className="el-listen-embed">
              <iframe
                src="https://open.spotify.com/embed/artist/4FVJdMWSQhn3zO1NKxMHAi?theme=0"
                width="100%"
                height="152"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="CloudfiMusic Spotify"
                style={{ borderRadius: 12 }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Artists */}
      <section className="el-roster">
        <div className="el-roster-header">
          <h2 className="el-roster-title">Our Artists</h2>
        </div>

        <div className="el-roster-grid">
          {loading
            ? Array.from({ length: 12 }).map((_, i) => (
                <div className="el-artist-card el-skeleton-card" key={i}>
                  <div className="el-artist-img-wrap">
                    <div className="skeleton" style={{ width: '100%', height: '100%' }} />
                  </div>
                </div>
              ))
            : artists.map((artist) => (
                <div
                  className="el-artist-card"
                  key={artist.spotify_id}
                  onClick={() => navigate(`/artists/${artist.spotify_id}`)}
                  data-testid={`artist-card-${artist.spotify_id}`}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && navigate(`/artists/${artist.spotify_id}`)}
                >
                  <div className="el-artist-img-wrap">
                    {artist.image_url ? (
                      <img src={artist.image_url} alt={artist.name} loading="lazy" />
                    ) : (
                      <div className="el-artist-placeholder" />
                    )}
                    <div className="el-artist-overlay" />
                    <span className="el-artist-name">{artist.name}</span>
                  </div>
                </div>
              ))}
        </div>
      </section>
    </div>
  );
}
